/*
 *
 *  * Copyright(c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import * as _ from 'underscore';
import { Logger } from '@core/lib/services';

const log = new Logger('SseSearchClientFactory');

export class SseSearchClientFactory {
  private listeners = {};

  updateSearchResults(searchCriteriaInfo, data, event) {
    if (event) {
      this.fireEvent(event, searchCriteriaInfo, data);
    }
  }

  on(event, listener, context): any {
    if (!_.isFunction(listener)) {
      log.error('sse-search-client-cache-factory - .on() - listener is not a function');
      return;
    }

    listener._context = context || null;

    if (this.listeners[event]) {
      this.listeners[event].push(listener);
    } else {
      this.listeners[event] = [listener];
    }

    return {
      unregister: () => {
        const index = this.listeners[event].indexOf(listener);
        if (index > -1) {
          this.listeners[event].splice(index, 1);
        }
      }
    };
  }

  fireEvent(event, searchCriteriaInfo, data) {
    const eventListeners = this.listeners[event];
    if (!eventListeners) {
      log.error('sse-search-client-factory -- .fireEvent() - no listeners have been registered');
    } else {
      _.each(eventListeners, listener => {
        listener.apply(listener._context, [searchCriteriaInfo, data]);
      });
    }
  }
}
